<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">運轉日誌</div>
      <div style="margin-top: 2rem">
        <commonQueryInput
          :inputItems="multiInputItems"
          :immediateInputValues="true"
          v-model:getValue="multiInputVal"
          v-model:getImmediateValue="immediateMultiInputVal"
        ></commonQueryInput>
      </div>
      <div style="margin-top: 2rem">
        <queryResultTable :queryResultTableItems="queryResultTableItems" />
      </div>
      <div style="margin-top: 2rem">
        <stackBar
          :stacksBarClass="stacksBarClass"
          :stacksBarMaxValue="stacksBarMaxValue"
          :stacksData="stacksData"
          :stacksSize="'normal'"
        />
      </div>
      <div class="text-end" style="margin-bottom: 0.6rem">
        <exportCsv
          :exportData="operateLogItems"
          :exportDataTitle="operateLogFields.map((item) => item.label)"
          :exportFileName="exportFileName()"
        />
      </div>
      <commonTable
        :fields="operateLogFields"
        :items="operateLogItems"
        :theme="'green'"
        stickyHeader="230px"
      >
        <template #cell(status)="data">
          <template
            v-if="
              data.item.alarmCode != '' &&
              data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
              data.item.status == '警報'
            "
          >
            <b style="color: red">{{ data.value }}</b>
          </template>
          <template v-else>
            {{ data.value }}
          </template>
        </template>
        <template #cell(alarmCode)="data">
          <template
            v-if="
              data.item.alarmCode != '' &&
              data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
              data.item.status == '警報'
            "
          >
            <b style="color: red">{{ data.value }}</b>
          </template>
          <template v-else>
            {{ data.value }}
          </template>
        </template>
        <template #cell(alarmDetail)="data">
          <template
            v-if="
              data.item.alarmCode != '' &&
              data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
              data.item.status == '警報'
            "
          >
            <b style="color: red">{{ data.value }}</b>
          </template>
          <template v-else>
            {{ data.value }}
          </template>
        </template>
        <template #cell(startTime)="data">
          <template
            v-if="
              data.item.alarmCode != '' &&
              data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
              data.item.status == '警報'
            "
          >
            <b style="color: red">{{ data.value }}</b>
          </template>
          <template v-else>
            {{ data.value }}
          </template>
        </template>
        <template #cell(endTime)="data">
          <template
            v-if="
              data.item.alarmCode != '' &&
              data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
              data.item.status == '警報'
            "
          >
            <b style="color: red">{{ data.value }}</b>
          </template>
          <template v-else>
            {{ data.value }}
          </template>
        </template>
        <template #cell(durationTime)="data">
          <template
            v-if="
              data.item.alarmCode != '' &&
              data.item.alarmCode.indexOf('E_MC_3_') != -1 &&
              data.item.status == '警報'
            "
          >
            <b style="color: red">{{ data.value }}</b>
          </template>
          <template v-else>
            {{ data.value }}
          </template>
        </template>
      </commonTable>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import queryResultTable from "@/components/queryResultTable.vue";
import stackBar from "@/components/stackBar.vue";
import exportCsv from "@/components/exportCsv.vue";
import commonTable from "@/components/commonTable.vue";
import { computed, inject, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    commonQueryInput,
    queryResultTable,
    stackBar,
    exportCsv,
    commonTable,
  },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const oper = computed(() => store.getters["selectOptions/get_oper"]);
    const device = computed(() => store.getters["selectOptions/get_device"]);
    const stacksBarClass = computed(
      () => store.getters["stackBar/get_stacksBarClass"]
    );
    const stacksBarMaxValue = computed(
      () => store.getters["stackBar/get_stacksBarMaxValue"]
    );
    const stacksBarDefault = computed(
      () => store.getters["stackBar/get_stacksBarDefault"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
      set_device: (payload) => {
        store.dispatch("selectOptions/set_device", payload);
      },
    };

    const path = inject("path");
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "date",
        label: "日期",
        type: "date", // date/dateBetween/text/select/
      },
      {
        key: "oper",
        label: "製程",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇製程 --",
        options: oper,
      },
      {
        key: "deviceID",
        label: "機台",
        type: "select",
        bindKey: "oper",
        checkEmpty: true,
        disableText: "-- 選擇機台 --",
        bindOptions: device,
      },
    ]);
    const immediateMultiInputVal = ref();

    //查詢回來的機台名稱
    const deviceName = ref("");

    //查詢結果表格資料
    const queryResultTableItems = ref([]);

    //運轉日誌資訊
    const operateLogFields = [
      {
        key: "status",
        label: "狀態",
        sortable: true,
        thStyle: {
          "min-width": "80px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "alarmCode",
        label: "代碼",
        sortable: true,
        thStyle: {
          "min-width": "110px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "alarmDetail",
        label: "代碼說明",
        sortable: true,
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "開始時間",
        sortable: true,
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "結束時間",
        sortable: true,
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "durationTime",
        label: "持續時間",
        sortable: true,
        thStyle: {
          "min-width": "115px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const operateLogItems = ref([]);
    const stacksData = ref(stacksBarDefault.value);

    //匯出資料的檔案名稱
    const exportFileName = () => {
      let exportFileName = "";
      if (deviceName.value != "") {
        exportFileName =
          "運轉日誌_" +
          deviceName.value +
          "_" +
          new Date().getFullYear() +
          ("0" + (new Date().getMonth() + 1)).slice(-2) +
          ("0" + new Date().getDate()).slice(-2);
      }
      return exportFileName;
    };

    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        methods.triggerLoadingBar();
        let params = {};
        params["webPage"] =
          sideNavPath.value.length != 0
            ? sideNavPath.value[sideNavPath.value.length - 1]
            : null;
        params["user"] = loginData.value.account;
        params["vuePage"] = path.value;
        console.log(path.value);
        params["methods"] = "POST";
        params["whichFunction"] = "OperateLog";
        params["startTime"] = newValue["date"]["startDate"] + " 00:00:00";
        params["oper"] = newValue["oper"];
        params["deviceID"] = newValue["deviceID"];
        console.log(params);
        methods.axiosAction(params).then(() => {
          console.log(axiosResult.value);
          let result = axiosResult.value;
          let response = result.Response;
          if (response == "ok") {
            let queryTableData = result.QueryTableData;
            deviceName.value = queryTableData[0].query_date[3];
            queryResultTableItems.value = [
              {
                date: queryTableData[0].query_date[0].split(" ")[0],
                site: queryTableData[0].query_date[1],
                oper: queryTableData[0].query_date[2],
                group: queryTableData[0].query_date[3],
                device: queryTableData[0].query_date[4],
              },
            ];
            // machine_data
            operateLogItems.value = queryTableData[0].total_data;
            console.log(stacksBarDefault.value);
            stacksData.value = queryTableData[0].machine_data;
            console.log(stacksData.value);
          } else {
            deviceName.value = "";
            queryResultTableItems.value = [];
            operateLogItems.value = [];
            stacksData.value = stacksBarDefault.value;
            methods.setTimeoutAlert(response);
          }
          methods.triggerLoadingBar();
        });
      },
      { deep: true }
    );

    const startTime = ref("");
    const process = ref("");
    // 查詢機台
    watch(
      immediateMultiInputVal,
      (newValue) => {
        if (newValue.date == "" || newValue.date == null) {
          if (
            newValue.date.startDate == "" ||
            newValue.date.startDate == null
          ) {
            return;
          }
        }
        if (newValue.oper == "" || newValue.oper == null) {
          return;
        }
        if (
          startTime.value == newValue.date.startDate &&
          process.value == newValue.oper
        ) {
          return;
        }
        let params = {};
        params["user"] = loginData.value.account;
        params["vuePage"] = "selectoption";
        params["methods"] = "GET";
        params["whichFunction"] = "GetDeviceOption";
        if (newValue.date != "" || newValue.date != null) {
          if (
            newValue.date.startDate != "" ||
            newValue.date.startDate != null
          ) {
            params["startTime"] = newValue.date.startDate;
          }
        }
        if (newValue.oper != "" || newValue.oper != null) {
          params["process"] = newValue.oper;
        } else {
          params["process"] = "-";
        }
        methods.axiosAction(params).then(() => {
          let result = axiosResult.value;
          if (result["Response"] == "ok") {
            methods.set_device(result.QueryTableData.device);
            startTime.value = newValue.date.startDate;
            process.value = newValue.oper;
          } else {
            let returnData = {};
            returnData[params.process] = [];
            methods.set_device(returnData);
            startTime.value = "";
            process.value = "";
          }
        });
      },
      { deep: true }
    );

    return {
      stacksBarClass,
      stacksBarMaxValue,
      stacksBarDefault,
      deviceName,
      multiInputVal,
      multiInputItems,
      immediateMultiInputVal,
      queryResultTableItems,
      operateLogFields,
      operateLogItems,
      stacksData,
      exportFileName,
    };
  },
};
</script>

<style></style>
